import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
} from '@angular/core';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { UserService } from 'src/app/core/user/user.service';
import { User } from 'src/app/core/user/user.type';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MenuComponent implements AfterViewInit, AfterViewChecked {
  collapsed = true;
  constructor(
    private _userService: UserService,
    private _router: Router,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    this._router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        this.collapsed = true
      }
    });
  }

  user?: any = null;
  ngAfterViewInit(): void {
    this.getUser();
  }

  ngAfterViewChecked() {
    this.changeDetectorRef.detectChanges();
  }
  getUser(): any {
    this.getUserData();
    return this.user;
  }

  getUserData() {
    this.user = this._userService.getUser();
  }
}
